import { Modal } from '@design-system/components/modal/modal';
import { LibraryVM } from '../view-models/library.viewModel';
import { Button } from '@design-system/components/button/button';
import { Input } from '@design-system/components/input/input';
import { useRef } from 'react';
import { CircularProgress } from '@mui/material';

export const RenameFolderModal = (p: LibraryVM) => {
  const input = useRef<HTMLInputElement>(null);
  const defaultValue =
    p.openModal.type === 'RenameFolder' ? p.openModal.value.name : undefined;
  const folderId =
    p.openModal.type === 'RenameFolder' ? p.openModal.value.id : 0;
  return (
    <Modal
      isOpen={p.openModal.type === 'RenameFolder'}
      onClose={() => p.dispatch('closeConfirmation')}
      title="Rename Folder"
      disableBackdropClick={true}
      hideCloseButton={true}
      modalClassName="w-full md:w-[450px]"
    >
      <div className="flex flex-col gap-6">
        <div>
          <Input
            ref={input}
            min={1}
            max={255}
            defaultValue={defaultValue}
            error={p.renameFolderError}
            onChange={() => {
              p.addFolderError && p.dispatch('clearRenameFolderError');
            }}
          />
        </div>
        <div className="flex justify-between">
          <Button
            onClick={() => p.dispatch('closeConfirmation')}
            color="neutral"
            variant="text"
            disabled={p.updateProgress}
          >
            Cancel
          </Button>
          <Button
            onClick={() =>
              input?.current?.value &&
              p.dispatch('renameFolder', {
                name: input.current.value,
                id: folderId,
              })
            }
            color="neutral"
            disabled={p.updateProgress}
          >
            {p.updateProgress ? <CircularProgress size={24} /> : 'Rename'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
